import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const infoIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="10" stroke="#0D6BB8" stroke-width="1.5"/>
<circle cx="12" cy="8" r="1" fill="#0D6BB8"/>
<rect x="11.25" y="11" width="1.5" height="6" rx="0.75" fill="#0D6BB8"/>
</svg>`,
);
